
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator
} from '@/components/ui/dropdown-menu';
import { Edit3, LogOut, User } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';

const EditorialMenu: React.FC = () => {
  const location = useLocation();
  const { user, signOut, isAuthenticated } = useAuth();
  
  const editorialLinks: Array<{ path: string; label: string }> = [
    { path: '/production', label: 'Produksjon' },
    { path: '/interview-requests', label: 'Intervjuforespørsler' },
    { path: '/interview-management', label: 'Intervjuadministrasjon' },
    { path: '/feeder', label: 'Publiseringskø' },
    { path: '/publish-history', label: 'Publiseringshistorikk' },
    { path: '/email-templates', label: 'E-post maler' },
    { path: '/editorial/ama', label: 'AMA Administrasjon' },
    { path: '/ai-dashboard', label: 'AI Dashboard' },
    { path: '/editorial-approval', label: 'Redaksjonell godkjenning' },
    { path: '/rag-metrics', label: 'RAG Metrics' },
  ];

  const enterpriseLinks: Array<{ path: string; label: string }> = [
    { path: '/enterprise', label: '🚀 Enterprise Dashboard' },
    { path: '/enterprise/attention-reports', label: '📊 Attention Reports' },
    { path: '/enterprise/ad-economy', label: 'Annonseøkonomi' },
    { path: '/booking', label: 'Booking (BB)' },
    { path: '/analytics', label: 'Analytikk & Innsikt' },
    { path: '/ab-testing', label: 'A/B Testing' },
    { path: '/alerts', label: 'Overvåkning & Varsler' },
    { path: '/backup', label: 'Sikkerhetskopi' },
    { path: '/monitoring', label: 'Systemovervåkning' },
  ];

  if (!isAuthenticated) {
    return (
      <Button asChild variant="outline">
        <Link to="/auth">
          <User className="h-4 w-4" />
          <span>Logg inn</span>
        </Link>
      </Button>
    );
  }
  
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline">
          <Edit3 className="h-4 w-4" />
          <span>Redaksjon</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-[600px] max-h-[80vh] overflow-y-auto">
        {/* Editorial section */}
        <div>
          <div className="py-2 px-4 text-sm text-center text-muted-foreground font-semibold bg-muted/50">
            Redaksjon
          </div>
          <div className="grid grid-cols-2 gap-1 p-2">
            {editorialLinks.map((link, index) => (
              <DropdownMenuItem key={`editorial-link-${index}`}>
                <Link to={link.path} className="w-full">
                  {link.label}
                </Link>
              </DropdownMenuItem>
            ))}
          </div>
        </div>

        {/* Enterprise section */}
        <div className="border-t">
          <div className="py-2 px-4 text-sm text-center text-muted-foreground font-semibold bg-muted/50">
            Enterprise
          </div>
          <div className="grid grid-cols-2 gap-1 p-2">
            {enterpriseLinks.map((link, index) => (
              <DropdownMenuItem key={`enterprise-link-${index}`}>
                <Link to={link.path} className="w-full">
                  {link.label}
                </Link>
              </DropdownMenuItem>
            ))}
          </div>
        </div>

        <DropdownMenuSeparator />
        <div className="p-2">
          <DropdownMenuItem className="text-muted-foreground">
            <User className="h-4 w-4 mr-2" />
            {user?.email}
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => signOut()} className="text-red-600">
            <LogOut className="h-4 w-4 mr-2" />
            Logg ut
          </DropdownMenuItem>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default EditorialMenu;
